import templateUrl from './scanner.view.html'

/**
 * Scanner detail Devices route
 *
 * @namespace routes.DevicesScannerView
 * @type {TmrRoute}
 */
export const route = {
  name: 'devices.scanners.view',
  label: 'DEVICES.SCANNERS.VIEW.TITLE',
  component: 'tmrDevicesScannerView',
  accessControl: ['Resource.view', 'Resource.Scanner.view'],
  abstract: false,
}

/**
 * Component for {@link routes.tmrDevicesScannerView Scanner Details route}
 *
 * @type {ngComponent}
 */
export const tmrDevicesScannerView = {
  ngType: 'component',
  templateUrl,
  bindings: {
    resource: '<',
  },
}
